import { DeckLeglaity, LegalityChecker } from '../deckLegality'
import { ERRORS } from '../legality.const'

const CheckLegality: LegalityChecker = (deck: DeckLeglaity) => {
  const fullDeck = [...deck.mainboard]

  for (const card of fullDeck) {
    deck.checkCardLegality(card)
    deck.checkCardQuantity(card, 1)
  }

  if (deck.deckSize !== 100) deck.addError(ERRORS.GLADIATOR_SIZE)
}

export default CheckLegality
